import ActionTypes from '../actions/types';

const initialState = {
  donations: [],
  total: 0,
};
// in this camera function, you can add actions that update state data.

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_DONATIONS:
      return {
        ...state,
        donations: action.payload.donations,
        total: action.payload.donations.reduce((total, donation) => {
          return total + donation.amount;
        }, 0)
      };
    default:
      return state;
  }
}
